import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from "@app/app/components/errors/not-found/not-found.component";
import { BusinessesComponent } from '@app/app/components/businesses/businesses.component';
import { BusinessDetailsComponent } from '@app/app/components/businesses/business-details/business-details.component';
import { saasFeatureGuard } from '@app/app/guards/saas-features.guard';
import { Store } from '@ngxs/store';
import { BusinessActions } from '@app/app/store/businesses/business.actions';

const routes: Routes = [
  {
    path: '', // /businesses - business-table
    component: BusinessesComponent,
    pathMatch: 'full',
  },
  {
    path: ':id', // /businesses/1 - business-details > overview
    component: BusinessDetailsComponent,
    canActivate: [saasFeatureGuard],
    data: {saasFeature: 'businessDetails'},
    resolve: [(route) => {
      const store = inject(Store);
      const id = route.params.id;
      !!id && store.dispatch(new BusinessActions.GetBusiness(id));
    }]
  },
  {
    path: '**',
    component: NotFoundComponent,
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessesRoutingModule {
}
